<template>
  <el-dialog
    title="物资收据"
    :visible.sync="dialogVisible"
    width="70%"
    @close="cancel"
  >
    <div class="materialsPrint" id="materialsPrint">
      <div class="printTitle">
        物&#12288;&#12288;资&#12288;&#12288;收&#12288;&#12288;据
      </div>
      <div class="printTime">
        {{ (dataForm.CreateTime * 1000) | formatDate }}
      </div>
      <div class="printRow">
        <div class="printCol borderRight">物资来源</div>
        <div class="printCol borderRight">调出库</div>
        <div class="printCol borderRight">品名</div>
        <div class="printCol borderRight">型号/规格</div>
        <div class="printCol borderRight">单位</div>
        <div class="printCol borderRight">单价(元)</div>
        <div class="printCol borderRight">数量</div>
        <div class="printCol">总价(元)</div>
      </div>
      <div class="printRow noRowTop" v-for="(item, index) in list" :key="index">
        <div class="printCol borderRight"></div>
        <div class="printCol borderRight"></div>
        <div class="printCol borderRight">{{ item.MaterialName }}</div>
        <div class="printCol borderRight">{{ item.MaterialType }}</div>
        <div class="printCol borderRight">{{ item.Unit }}</div>
        <div class="printCol borderRight">{{ item.UnitPrice }}</div>
        <div class="printCol borderRight">{{ item.Number }}</div>
        <div class="printCol">{{ item.Amount }}</div>
      </div>
      <div class="printRow noRowTop">
        <div class="printCol-total borderRight">合&#12288;&#12288;计:</div>
        <div class="printCol borderRight">{{ totalNum }}</div>
        <div class="printCol">{{ totalAmount }}</div>
      </div>
      <div class="printRow noRowTop">
        <div class="printCol borderRight">备注：</div>
        <div class="printCol"></div>
        <div class="printCol"></div>
        <div class="printCol"></div>
        <div class="printCol"></div>
        <div class="printCol"></div>
        <div class="printCol"></div>
        <div class="printCol"></div>
      </div>
      <div class="printRow noBorder">
        <div class="printCol">经手人:</div>
        <div class="printCol"></div>
        <div class="printCol">核准人:</div>
        <div class="printCol"></div>
        <div class="printCol">批准人:</div>
        <div class="printCol"></div>
        <div class="printCol">填写单位(盖章)</div>
        <div class="printCol"></div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" v-print="'#materialsPrint'">打 印</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/modules/zjrc/api";
export default {
  name: "print",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: true,
      list: [],
      totalNum: 0,
      totalAmount: 0,
    };
  },
  mounted() {
    let that = this;
    that.getList();
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //获取物资详情
    getList() {
      let that = this;
      let params = { Id: this.dataForm.Id };
      api.QueryMaterialsDetailById(params).then(function (res) {
        that.list = res.data.Data;
        console.log(that.list);
        that.totalNum = 0;
        that.totalAmount = 0;
        that.list.forEach(function (item) {
          that.totalAmount += item.Amount;
          that.totalNum += item.Number;
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.materialsPrint {
  width: 100%;
  padding: 10px;
  .printTitle {
    text-align: center;
    padding: 10px;
    font-size: 22px;
  }
  .printTime {
    text-align: right;
    padding: 5px;
  }
  .bd-r {
    position: relative;
  }
  .bd-r::after {
    content: "";
    width: 0.5px;
    height: 100%;
    position: absolute;
    background-color: #121212;
    top: 0;
    right: 0;
  }
  .printRow {
    display: flex;
    border: 1px solid #333;
    .printCol {
      box-sizing: border-box;
      flex: 0 0 12.5%;
      padding: 5px;
      text-align: center;
    }
    .printCol-total {
      flex: 0 0 75%;
      padding: 5px;
      text-align: center;
    }
  }
  .noRowTop {
    border-top: none;
  }
  .noBorder {
    border: none;
  }
  .borderRight {
    border-right: 0.125em solid #333;
  }
}
</style>